/**
 * The order the risk levels should be sorted in.
 */
const riskMap = {
  NOT_PROCESSED: 0,
  GREEN: 1,
  YELLOW: 2,
  RED: 3
}

/**
 * Sort risk values by their risk level
 */
export const riskComparator = (filterValue, cellValue) =>
  riskMap[filterValue] - riskMap[cellValue]

export const dateComparator = (filterLocalDateAtMidnight, cellValue) => {
  const cellDateAtMidnight = new Date(cellValue).setHours(0, 0, 0, 0)
  return cellDateAtMidnight - filterLocalDateAtMidnight
}

/**
 * Converts datetime to date-only filter, ensuring both date-only
 * values are compared without the user's timezone
 */
export const dateOnlyComparator = (filterLocalDateAtMidnight, cellValue) => {
  const filteredDate = new Date(filterLocalDateAtMidnight) // User's timezone
  const filteredDateUTC = Date.UTC(filteredDate.getFullYear(), filteredDate.getMonth(), filteredDate.getDate())
  return new Date(cellValue).getTime() - filteredDateUTC
}

/**
 * Custom comparator for text values that handles null values.
 * @param {string|null} filterValue
 * @param {string|null} cellValue
 * @returns {number} A value indicating the sort order of the two strings.
 */
export const textComparator = (filterValue, cellValue) => (filterValue === null || cellValue === null)
  ? (filterValue === cellValue ? 0 : (filterValue === null ? -1 : 1))
  : filterValue.localeCompare(cellValue)
